import './../../index.css';
import { jsx, jsxs } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-D_LIh_94.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const RUSize24Component = (props, ref) => (jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsxs("g", { children: [jsx("rect", { y: 3, width: 24, height: 18, rx: 3, fill: "#DADADA" }), jsx("path", { d: "M0 6C0 4.34315 1.34315 3 3 3H21C22.6569 3 24 4.34315 24 6V9H0V6Z", fill: "#EEEEEE" }), jsx("rect", { y: 9, width: 24, height: 6, fill: "#22408C" }), jsx("path", { d: "M0 15H24V18C24 19.6569 22.6569 21 21 21H3C1.34315 21 0 19.6569 0 18V15Z", fill: "#CE2028" })] }) }));
const RUSize24 = hoc(forwardRef(RUSize24Component), 'RUSize24');

export { RUSize24 as default };
//# sourceMappingURL=RUSize24.js.map
